<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header">Lista de Precios</h5>
                <div class="form-desc">Adición / Edición de Lista de Precios</div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        v-bind:class="{ 'text-danger': current.errors.nombre && current.errors.nombre.length > 0 }"
                      >Nombre</label>
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{ 'is-invalid': current.errors.nombre && current.errors.nombre.length > 0 }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          checked
                          class="form-check-input"
                          name="optionsRadios"
                          v-model="current.estatus"
                          type="radio"
                          value="true"
                        />Activo
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          v-model="current.estatus"
                          name="optionsRadios"
                          type="radio"
                          value="false"
                        />Inactivo
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">Guardar</button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-lista_precios', params: {  }}"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!--ListaPrecioProductoListadoComponent v-if="current.id != 0" :lista_precio="current.id" /-->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import Notifications from "@/notifications/notifications";
//import ListaPrecioProductoListadoComponent from "@/components/cat/lista_precios/ListaPrecioProductoListadoComponent";

export default {
  components: {
    //ListaPrecioProductoListadoComponent
  },
  data() {
    return {
      current: {
        id: 0,
        nombre: "",
        errors: {
          nombre: []
        }
      }
    };
  },
  computed: {},
  mounted() {
    if (this.$route.params.id) {
      ListaPreciosService.getById(this.$route.params.id).then(response => {
        this.current = response.data;
        this.current.errors = [];
      });
    }
  },
  methods: {
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      if (self.$route.params.id) {
        current.pk = self.$route.params.id
      }
      ListaPreciosService.save(current)
        .then(res => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Lista de Precio",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-lista_precios-editar",
            params: {
              id: self.current.id
            }
          });
        })
        .catch(error => {
          Vue.nextTick(function() {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    }
  }
};
</script>
